<template>
  <div class="content">
    <controlbar @input-event="setMessageHistory"> </controlbar>
    <div class="center">
      <table class="content_title" rules="rows">
        <tr class="items_table">
          <th class="space"></th>
          <td class="table_contents">
            <label class="user_id_label">
              {{ userIdLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="to_name_label">
              {{ toNameLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="send_datetime_label">
              {{ sendDateTimeLabel }}
            </label>
          </td>
          <td class="table_contents">
            <label class="message_label">
              {{ messageLabel }}
            </label>
          </td>
        </tr>
      </table>

      <div class="table_scroll" :style="{height: tableHeight}">
        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="dispMessageHistory in messageHistories"
            :key="dispMessageHistory.id"
          >
            <th class="space"></th>
            <td class="table_contents" @click="setActive(dispMessageHistory)">
              <label class="user_id">
                {{ dispMessageHistory.userId }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispMessageHistory)">
              <label class="to_name">
                {{ dispMessageHistory.familyName }}{{ dispMessageHistory.name }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispMessageHistory)">
              <label class="send_datetime_name">
                {{ formatedDate(dispMessageHistory.sendDateTime) }}
              </label>
            </td>
            <td class="table_contents" @click="setActive(dispMessageHistory)">
              <label class="message">
                {{ dispMessageHistory.message }}
              </label>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="bottom">
      <pagination
        v-model="page"
        :records="total"
        :per-page="pageSize"
        :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
        @paginate="setMessageHistory(page - 1)"
      >
      </pagination>
    </div>
    <div class="false_modal_window" v-if="showFalseModal">
      <falseModalWindow :question="falseWord" @close="close">
      </falseModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import controlbar from './controlbar.vue'
import Pagination from 'vue-pagination-2'
import falseModalWindow from '../modalWindow/finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      userIdLabel: 'ユーザID',
      toNameLabel: '名前',
      sendDateTimeLabel: '送信日時',
      messageLabel: 'メッセージ',
      showFalseModal: false,
      windowHeight: '',
      falseWord: '',
      inputValue: '',
      showloadingModal: false,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      prevPageNo: 0,
      prevSearchWord: ''
    }
  },
  computed: {
    messageHistories() {
      return this.$store.state.messageHistory.messageHistories
    },
    total() {
      if (
        (this.page - 1) * this.pageSize <=
        this.$store.state.messageHistory.total
      ) {
        return this.$store.state.messageHistory.total
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >=
        this.$store.state.messageHistory.total
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.messageHistory.total / this.pageSize
      )
      return last === 0 ? 1 : last
    },
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    tableHeight() {
      const otherHeight = 138
      return this.windowHeight - otherHeight + 'px'
    }
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.$store.state.prevPageNo = 0
    this.$store.state.prevSearchWord = ''
    this.setMessageHistory(0)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  components: {
    controlbar,
    Pagination,
    falseModalWindow,
    loadingModalWindow
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    close(e) {
      this.showFalseModal = false
    },
    formatedDate(unixTime) {
      const targetDate = new Date(unixTime)
      return `${targetDate.getFullYear()}/${(targetDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${targetDate
        .getDate()
        .toString()
        .padStart(2, '0')} ${targetDate
        .getHours()
        .toString()
        .padStart(2, '0')}:${targetDate
        .getMinutes()
        .toString()
        .padStart(2, '0')}`
    },
    async reload() {
      await this.setMessageHistory(
        this.$store.state.prevPageNo,
        this.$store.state.prevSearchWord
      )
    },
    async setMessageHistory(pageNo, searchWord = null) {
      this.showloadingModal = true
      let focus = document.activeElement
      focus.blur()
      try {
        searchWord =
          searchWord === null ? this.$store.state.prevSearchWord : searchWord
        await this.$store.dispatch('messageHistory/setMessageHistory', {
          pageNo: pageNo,
          searchWord: searchWord
        })
        if (pageNo > 0) {
          if (this.isOverPage) {
            this.page = this.lastPage
          } else {
            this.page = pageNo + 1
          }
        } else {
          this.page = 1
        }
        this.$store.state.prevPageNo = pageNo
        this.$store.state.prevSearchWord = searchWord
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_720001
        let eventType = 3
        let reason = 'MSGCRC0315 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0315.name +
            this.errorMsg.MSGCRC0315.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    },
    async setActive(payload) {
      this.showloadingModal = true
      let tr = event.currentTarget.parentNode.parentNode.querySelectorAll('tr')
      for (let i = 0; i < tr.length; i++) {
        tr[i].className = 'item_table_row'
      }
      event.currentTarget.parentNode.className = 'item_table_row active'
      try {
        await this.$store.dispatch(
          'messageHistory/setDetailMessageHistory',
          payload
        )

        try {
          if (
            this.$store.state.messageHistory.messageHistory.thumbnailPhotograph
          ) {
            await this.$store.dispatch(
              'messageHistory/fileDownload',
              this.$store.state.messageHistory.messageHistory
                .thumbnailPhotograph
            )
          }
          if (location.pathname !== '/messageHistory/detail') {
            this.$router.push('../messageHistory/detail')
          }
        } catch (error) {
          this.$store.dispatch(
            'messageHistory/setNoimageChangeThumbnailPhotograph'
          )
          let eventNumber = this.$store.state.error.errorCode.errorCode_720001
          let eventType = 3
          let reason = 'MSGCRC0196 '
          this.falseWord =
            this.errorMsg.MSGCRC0196.name +
            this.errorMsg.MSGCRC0196.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          try {
            this.$store.dispatch('masters/writeLog', {
              eventNumber,
              eventType,
              reason
            })
          } catch (error) {}
          // 画像ダウンロード失敗の場合でも画面遷移する
          if (location.pathname !== '/messageHistory/detail') {
            this.$router.push('../messageHistory/detail')
          }
          this.showFalseModal = true
        }
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_720001
        let eventType = 3
        let reason = 'MSGCRC0316 '
        if (error.response) {
          this.falseWord =
            this.errorMsg.MSGCRC0316.name +
            this.errorMsg.MSGCRC0316.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.falseWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showFalseModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>

<style scoped>
td {
  width: 20%;
}
td:nth-child(4) {
  table-layout: fixed;
  width: 22%;
}
.space {
  width: 2%;
}
.items_table {
  table-layout: fixed;
  width: 100%;
}
.message {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/messageHistory/messageHistoryList.vue